import React, { useCallback } from 'react';
import SimpleModal from '../../../../../SimpleModal';
import JsonEditor from '../../../../../JsonEditor';
import { useParams } from 'react-router';

const AddInvitationModal = ({
  formData,
  onCloseModal = () => {},
  onSubmit = () => {},
  onChange = () => {},
  schema,
  uiSchema,
  invitations,
  submitDisabled,
}) => {
  const { id: siteId } = useParams();

  const handleSubmit = ({ formData: userData }) => {
    onSubmit(userData);
  };

  const onFormChange = ({ formData: updatedFormData }) => {
    onChange({ ...updatedFormData });
  };

  const customValidate = useCallback(
    (userInput, errors) => {
      invitations.forEach((invitation) => {
        if (
          invitation.email.toLowerCase() === userInput.email.toString().toLowerCase() &&
          Object.values(invitation.roles || {}).some((siteIds) => siteIds.includes(siteId))
        ) {
          errors.email.addError(
            `An invitation for ${invitation.email.toLowerCase()} already exists.`
          );
        }
      });
      return errors;
    },

    [invitations]
  );

  return (
    <SimpleModal
      onClose={onCloseModal}
      allowOverlayScroll
      className="add-user-modal-component"
      title="Invite users"
    >
      <div className="add-user-modal">
        <JsonEditor
          submitDisabled={submitDisabled}
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          saveButtonText={'Save'}
          onFormChange={onFormChange}
          customValidate={customValidate}
          initialEditMode
          showEditButton={false}
          cancelCallback={onCloseModal}
          onFormSubmit={handleSubmit}
          editorOnly
        />
      </div>
    </SimpleModal>
  );
};

export default AddInvitationModal;
